import { useEffect } from "react";

import { privateApi } from "../config/api";

import useAuth from "./useAuth";
import useRefreshToken from "./useRefreshToken";

const usePrivateApi = () => {
  const { auth } = useAuth();
  const refreshToken = useRefreshToken();

  useEffect(() => {
    const requestIntercept = privateApi.interceptors.request.use(
      (config) => {
        if (!config.headers["authorization"]) {
          config.headers["authorization"] = `Bearer ${auth?.accessToken}`;
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = privateApi.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config;

        if (error?.response?.status === 403 && !prevRequest?.sent) {
          prevRequest.sent = true;

          try {
            const accessToken = await refreshToken();
            prevRequest.headers["authorization"] = `Bearer ${accessToken}`;

            return privateApi(prevRequest);
          } catch (err) {
            console.error(err);
          }
        }

        return Promise.reject(error);
      }
    );

    return () => {
      privateApi.interceptors.request.eject(requestIntercept);
      privateApi.interceptors.response.eject(responseIntercept);
    };
  }, [auth, auth.accessToken, refreshToken]);

  return privateApi;
};

export default usePrivateApi;
